/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useParams } from 'react-router-dom';

import 'react-step-progress-bar/styles.css';

import { Typography, Divider, Box } from '@mui/material';

import ButtonBack from '../../../shared/components/ButtonBack';
import { ButtonPrimary } from '../../../shared/components';
import TagStatus from '../../../shared/components/TagStatus';
import TitlePage from '../../../shared/components/TitlePage';
import { HeaderPage } from '../OrderList/styles';
import { InfoHeader } from './components/InfoHeader';
import { ItemsTable } from './components/ItemsTable';
import { OrderNotes } from './components/OrderNotes';
import { StatusStepBar } from './components/StatusStepBar';
import { useApproveOrRejectOrder } from './hooks/use-approve-or-reject-order';
import { useGetOrderDetails } from './hooks/use-get-order-details';
import { useResendOrderCode } from './hooks/use-resend-order-code';
import { useResendReturnMethodSelection } from './hooks/use-resend-return-method-selection';
import { useUpdateOrder } from './hooks/use-update-order';
import { RoutesMapping } from '../../../core/route/routesMapping';

const OrderStatus = {
  WAITING: 1,
  PENDING: 2,
  APPROVED: 3,
  SENT: 4,
  RECEIVED: 5,
  RESOLVED: 6,
  REJECTED: 7,
};

export function OrderDetails() {
  const { orderId } = useParams();
  const { orderDetails, getOrderDetails } = useGetOrderDetails({ orderId });
  const { approveOrRejectOrder, loading: approving } =
    useApproveOrRejectOrder();
  const { resendOrderCode, loading: sendingOrderCode } = useResendOrderCode();
  const { resendReturnMethodSelection, loading: sendingSelectReturnMethod } =
    useResendReturnMethodSelection();
  const { updateOrder } = useUpdateOrder();

  return (
    <>
      <ButtonBack previousPage={RoutesMapping.ORDERS} />
      <div style={{ height: '20px' }} />
      {orderDetails && (
        <>
          <HeaderPage>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '30px',
              }}
            >
              <TitlePage label={`Pedido ${orderDetails.code}`} />
              <TagStatus
                label={orderDetails.status.name}
                status={orderDetails.status.name}
              />
            </div>
            <Box sx={{ display: 'flex' }}>
              {orderDetails.status.index === OrderStatus.PENDING && (
                <>
                  <ButtonPrimary.Normal
                    type="outline"
                    color="red"
                    label="REJEITAR PEDIDO"
                    onClick={async () => {
                      await approveOrRejectOrder({ orderId, choice: false });
                      await getOrderDetails(orderId);
                    }}
                  />
                  <Box sx={{ width: '10px' }} />
                  <ButtonPrimary.Normal
                    label="APROVAR PEDIDO"
                    isLoading={approving}
                    onClick={async () => {
                      await approveOrRejectOrder({ orderId, choice: true });
                      await getOrderDetails(orderId);
                    }}
                  />
                </>
              )}
              {orderDetails.status.index === OrderStatus.WAITING && (
                <ButtonPrimary.Normal
                  type="outline"
                  label="REENVIAR LINK"
                  isLoading={sendingSelectReturnMethod}
                  onClick={async () => {
                    await resendReturnMethodSelection({ orderId });
                  }}
                />
              )}
              {orderDetails.status.index === OrderStatus.APPROVED && (
                <ButtonPrimary.Normal
                  type="outline"
                  label="REENVIAR PEDIDO"
                  isLoading={sendingOrderCode}
                  onClick={async () => {
                    await resendOrderCode({ orderId });
                  }}
                />
              )}
            </Box>
          </HeaderPage>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexFlow: 'wrap',
              bgcolor: 'background.paper',
              borderRadius: '6px',
              padding: '25px',
            }}
          >
            <InfoHeader orderDetails={orderDetails} />
            <Divider sx={{ margin: '30px 0', width: '100%' }} />
            <Typography variant="h6">
              <Box sx={{ fontWeight: 'bold' }}> Status do pedido</Box>
            </Typography>
            <StatusStepBar orderDetails={orderDetails} />
            <Divider sx={{ margin: '30px 0', width: '100%' }} />
            <Typography variant="h6">
              <Box sx={{ fontWeight: 'bold' }}> Items</Box>
            </Typography>
            <ItemsTable orderDetails={orderDetails} />
            <Divider sx={{ margin: '30px 0', width: '100%' }} />
            <OrderNotes
              orderDetails={orderDetails}
              saveNotes={async (newNotes) => {
                await updateOrder({ orderId, note: newNotes });
                await getOrderDetails(orderId);
              }}
            />
          </Box>
        </>
      )}
    </>
  );
}
